var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-row",
    { attrs: { gutter: 24 } },
    [
      _c(
        "a-col",
        { attrs: { md: 24 } },
        [
          _c(
            "a-card",
            { style: _vm.cardStyle, attrs: { bordered: false } },
            [
              _c(
                "div",
                { staticClass: "table-page-search-wrapper" },
                [
                  _c(
                    "a-form",
                    {
                      attrs: { layout: "inline" },
                      nativeOn: {
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          )
                            return null
                          return _vm.searchQuery.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c(
                        "a-row",
                        { attrs: { gutter: 24 } },
                        [
                          _c(
                            "a-col",
                            { attrs: { md: 6, sm: 24 } },
                            [
                              _c(
                                "a-form-item",
                                {
                                  attrs: {
                                    label: "仓库名称",
                                    labelCol: _vm.labelCol,
                                    wrapperCol: _vm.wrapperCol,
                                  },
                                },
                                [
                                  _c("a-input", {
                                    attrs: {
                                      placeholder: "请输入仓库名称查询",
                                    },
                                    model: {
                                      value: _vm.queryParam.name,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.queryParam, "name", $$v)
                                      },
                                      expression: "queryParam.name",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "a-col",
                            { attrs: { md: 6, sm: 24 } },
                            [
                              _c(
                                "a-form-item",
                                {
                                  attrs: {
                                    label: "备注",
                                    labelCol: _vm.labelCol,
                                    wrapperCol: _vm.wrapperCol,
                                  },
                                },
                                [
                                  _c("a-input", {
                                    attrs: { placeholder: "请输入备注查询" },
                                    model: {
                                      value: _vm.queryParam.remark,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.queryParam, "remark", $$v)
                                      },
                                      expression: "queryParam.remark",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "span",
                            {
                              staticClass: "table-page-search-submitButtons",
                              staticStyle: {
                                float: "left",
                                overflow: "hidden",
                              },
                            },
                            [
                              _c(
                                "a-col",
                                { attrs: { md: 6, sm: 24 } },
                                [
                                  _c(
                                    "a-button",
                                    {
                                      attrs: { type: "primary" },
                                      on: { click: _vm.searchQuery },
                                    },
                                    [_vm._v("查询")]
                                  ),
                                  _c(
                                    "a-button",
                                    {
                                      staticStyle: { "margin-left": "8px" },
                                      on: { click: _vm.searchReset },
                                    },
                                    [_vm._v("重置")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "table-operator",
                  staticStyle: { "margin-top": "5px" },
                },
                [
                  _vm.btnEnableList.indexOf(1) > -1
                    ? _c(
                        "a-button",
                        {
                          attrs: { type: "primary", icon: "plus" },
                          on: { click: _vm.handleAdd },
                        },
                        [_vm._v("新增")]
                      )
                    : _vm._e(),
                  _vm.btnEnableList.indexOf(1) > -1
                    ? _c(
                        "a-button",
                        {
                          attrs: { icon: "delete" },
                          on: { click: _vm.batchDel },
                        },
                        [_vm._v("删除")]
                      )
                    : _vm._e(),
                  _vm.btnEnableList.indexOf(1) > -1
                    ? _c(
                        "a-button",
                        {
                          attrs: { icon: "check-square" },
                          on: {
                            click: function ($event) {
                              return _vm.batchSetStatus(true)
                            },
                          },
                        },
                        [_vm._v("启用")]
                      )
                    : _vm._e(),
                  _vm.btnEnableList.indexOf(1) > -1
                    ? _c(
                        "a-button",
                        {
                          attrs: { icon: "close-square" },
                          on: {
                            click: function ($event) {
                              return _vm.batchSetStatus(false)
                            },
                          },
                        },
                        [_vm._v("禁用")]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "div",
                [
                  _c("a-table", {
                    ref: "table",
                    attrs: {
                      size: "middle",
                      bordered: "",
                      rowKey: "id",
                      columns: _vm.columns,
                      dataSource: _vm.dataSource,
                      pagination: _vm.ipagination,
                      scroll: _vm.scroll,
                      loading: _vm.loading,
                      rowSelection: {
                        selectedRowKeys: _vm.selectedRowKeys,
                        onChange: _vm.onSelectChange,
                      },
                    },
                    on: { change: _vm.handleTableChange },
                    scopedSlots: _vm._u([
                      {
                        key: "action",
                        fn: function (text, record) {
                          return _c(
                            "span",
                            {},
                            [
                              _vm.btnEnableList.indexOf(1) > -1 &&
                              _vm.depotFlag === "1" &&
                              _vm.quickBtn.user.indexOf(1) > -1
                                ? _c(
                                    "a",
                                    {
                                      on: {
                                        click: function ($event) {
                                          return _vm.btnSetUser(record)
                                        },
                                      },
                                    },
                                    [_vm._v("分配用户")]
                                  )
                                : _vm._e(),
                              _vm.btnEnableList.indexOf(1) > -1 &&
                              _vm.depotFlag === "1" &&
                              _vm.quickBtn.user.indexOf(1) > -1
                                ? _c("a-divider", {
                                    attrs: { type: "vertical" },
                                  })
                                : _vm._e(),
                              _vm.btnEnableList.indexOf(1) > -1
                                ? _c(
                                    "a-popconfirm",
                                    {
                                      attrs: { title: "确定设为默认吗?" },
                                      on: {
                                        confirm: () =>
                                          _vm.handleSetDefault(record.id),
                                      },
                                    },
                                    [_c("a", [_vm._v("设为默认")])]
                                  )
                                : _vm._e(),
                              _vm.btnEnableList.indexOf(1) > -1
                                ? _c("a-divider", {
                                    attrs: { type: "vertical" },
                                  })
                                : _vm._e(),
                              _c(
                                "a",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleEdit(record)
                                    },
                                  },
                                },
                                [_vm._v("编辑")]
                              ),
                              _vm.btnEnableList.indexOf(1) > -1
                                ? _c("a-divider", {
                                    attrs: { type: "vertical" },
                                  })
                                : _vm._e(),
                              _vm.btnEnableList.indexOf(1) > -1
                                ? _c(
                                    "a-popconfirm",
                                    {
                                      attrs: { title: "确定删除吗?" },
                                      on: {
                                        confirm: () =>
                                          _vm.handleDelete(record.id),
                                      },
                                    },
                                    [_c("a", [_vm._v("删除")])]
                                  )
                                : _vm._e(),
                            ],
                            1
                          )
                        },
                      },
                      {
                        key: "customRenderEnabledFlag",
                        fn: function (enabled) {
                          return [
                            enabled
                              ? _c("a-tag", { attrs: { color: "green" } }, [
                                  _vm._v("启用"),
                                ])
                              : _vm._e(),
                            !enabled
                              ? _c("a-tag", { attrs: { color: "orange" } }, [
                                  _vm._v("禁用"),
                                ])
                              : _vm._e(),
                          ]
                        },
                      },
                      {
                        key: "customRenderFlag",
                        fn: function (isDefault) {
                          return [
                            isDefault
                              ? _c("a-tag", { attrs: { color: "green" } }, [
                                  _vm._v("是"),
                                ])
                              : _vm._e(),
                            !isDefault
                              ? _c("a-tag", { attrs: { color: "orange" } }, [
                                  _vm._v("否"),
                                ])
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _c("depot-modal", {
                ref: "modalForm",
                on: { ok: _vm.modalFormOk },
              }),
              _c("depot-user-modal", { ref: "depotUserModal" }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }